import { isDefined } from 'ionic-angular/util/util';
import { Observable } from 'rxjs/Observable';
import { from } from 'rxjs/observable/from';
import { of } from 'rxjs/observable/of';
import { VasAppFacade } from '../../../vas/services/vas-app-facade.service';
import { VASRestService } from '../api/vas-rest';
import { FileChangeQItem } from './file-item';
import { ChangeQItem } from './item';
import { OperationResult } from './operation-result';
import { IOperation } from './operation.interface';
import { DefaultOperation } from './operations/default-operation';
import { FieldOperation } from './operations/field-operation';
import { FileOperation } from './operations/file-operation';
import { ReportLayoutOperation } from './operations/report-layout-operation';
import { ResultHandler } from './result-handler';

export class OperationSequence {

    logToConsole = false;

    constructor(
        protected appFacade: VasAppFacade,
        protected restService: VASRestService
    ) {

    }

    sync(changeQItems?: Array<ChangeQItem>): Observable<any> {

        const items$ = isDefined(changeQItems) ? of(changeQItems) : this.getChangeItems();

        this.logToConsole && console.log('syncup()');
        return items$
        //  convert each change item to an operation
            .map((items: Array<ChangeQItem>) => {
                this.logToConsole && console.log('> items', items.length);
                const steps = this.changeQItemsToOperations(items);
                this.logToConsole && console.log('> steps', steps.length, steps);
                return steps;
            })
            // for each transaction
            .concatMap((transactions: Array<IOperation>) => {
                return from(transactions)

                    .concatMap((transaction: IOperation) => {
                        this.logToConsole && console.log('>> sync group', transaction);
                        // sync the group
                        return transaction.sync()
                        //  convert the transactions result to a group handler
                            .map((result: OperationResult) => {
                                const handler = this.resultToGroupHandler(result);
                                this.logToConsole && console.log('>> group result handler', handler);
                                return handler;
                            })
                            // execute the handler
                            .concatMap((handler: ResultHandler) => {
                                this.logToConsole && console.log('>> executing handler with %s actions', handler.getActions().length);
                                return Observable.fromPromise(handler.handle());
                            });
                    });
            });
    }

    getChangeItems(): Observable<Array<ChangeQItem>> {
        return Observable.fromPromise(this.appFacade.changeLog.getAllItems());
    }

    protected changeQItemsToOperations(items: Array<ChangeQItem>): Array<IOperation> {
        return items.map(item => {
            switch (item.entity) {
                case 'file':
                    return new FileOperation(item as FileChangeQItem, this.restService, this.appFacade);
                case 'reportLayout':
                    return new ReportLayoutOperation(item, this.restService, this.appFacade);
                case 'field':
                    return new FieldOperation(item, this.restService, this.appFacade);
                default:
                    return new DefaultOperation(item, this.restService, this.appFacade);
            }
        });
    }

    protected resultToGroupHandler(result: OperationResult): ResultHandler {
        return new ResultHandler(
            result,
            this.appFacade
        );
    }
}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/operation-sequence.ts